import React from 'react';
import LocalizedStrings from 'react-localization';
import TextWidget from '../TextWidget/TextWidget.js'

class MeetingRoomWidget extends React.Component {

  constructor(props) {
    super(props);
    this.strings = new LocalizedStrings({
     en:{
       busy:'{0} is busy until',
       free:'{0} is free until',
       available:'{0} is available',
       freeTime:'{0}',
       busyTime:'{0}',
       now:'NOW'
     },
     de: {
       busy:'{0} bis',
       free:'{0} bis',
       available:'{0} ist',
       freeTime:'{0} verfügbar',
       busyTime:'{0} reserviert',
       now:'jetzt verfügbar'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  processEvents() {

    if(this.props.events && this.props.events.length > 0) {
      if(this.props.events.length === 1) {

        const nextMeeting = this.props.events[0];

        if(nextMeeting.currentMeeting) {
          return {
            line1: this.strings.formatString(this.strings.busy, this.props.meetingRoomName),
            line2: this.strings.formatString(this.strings.busyTime, nextMeeting.endTime)
          }
        } else {
          return {
            line1: this.strings.formatString(this.strings.free, this.props.meetingRoomName),
            line2: this.strings.formatString(this.strings.freeTime, nextMeeting.startTime)
          }
        }

      } else {

        var firstMeeting = this.props.events[0];
        var nextMeeting = this.props.events[1];

        if(firstMeeting.currentMeeting && firstMeeting.endTime !== nextMeeting.startTime) {
          return {
            line1: this.strings.formatString(this.strings.busy, this.props.meetingRoomName),
            line2: this.strings.formatString(this.strings.busyTime, firstMeeting.endTime)
          }
        } else if(!firstMeeting.currentMeeting) {
          return {
            line1: this.strings.formatString(this.strings.free, this.props.meetingRoomName),
            line2: this.strings.formatString(this.strings.freeTime, firstMeeting.startTime)
          }
        } else {
          var endTime = firstMeeting.endTime;

          for(var i = 1; i < this.props.events.length; i++) {
            var event = this.props.events[i];
            if(endTime === event.startTime) {
              endTime = event.endTime
            } else {
              return {
                line1: this.strings.formatString(this.strings.busy, this.props.meetingRoomName),
                line2: this.strings.formatString(this.strings.busyTime, event.endTime)
              }
            }
          }

          return {
            line1: this.strings.formatString(this.strings.busy, this.props.meetingRoomName),
            line2: this.strings.formatString(this.strings.busyTime, endTime)
          }
        }

      }

    } else {
      return {
        line1: this.strings.formatString(this.strings.available, this.props.meetingRoomName),
        line2: this.strings.now,
      }
    }

  }

  render() {

    const eventDisplayInfo = this.processEvents();

    return (
      <TextWidget {...this.props} title={eventDisplayInfo.line1} value={eventDisplayInfo.line2}/>
    )
  }
}

export default MeetingRoomWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/MeetingRoomWidget/MeetingRoomWidget.js